import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function MetaAds() {
  return (
    <ToolShell
      testid="tool-meta-ads-page"
      eyebrow="Pro Tool" toolKey="meta_ads"
      title="Meta Ads Creative Generator"
      subtitle="Three split-test creatives for Facebook & Instagram, with targeting hints."
      endpoint="/tools/meta-ads"
      tier="pro"
      transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "objective", label: "Campaign objective", type: "text", required: true, placeholder: "e.g. Leads for a free dive consultation" },
        { key: "offer", label: "What you're advertising", type: "textarea", rows: 3, placeholder: "e.g. Free 15-min Zoom audit of your dive content" },
        { key: "audience_notes", label: "Audience notes (optional)", type: "text", placeholder: "e.g. Self-funded recreational divers, 28-45" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-objective" label="Objective">{o.campaign_objective}</OutputBlock>
          {o.audience_targeting && (
            <OutputBlock testid="output-targeting" label="Audience Targeting">
              <div className="space-y-2 text-[14.5px]">
                <div><span className="dms-label">Interests</span><div className="mt-1 flex flex-wrap gap-2">{(o.audience_targeting.interests || []).map((x, i) => <span key={i} className="dms-badge">{x}</span>)}</div></div>
                <div><span className="dms-label">Behaviours</span><div className="mt-1 flex flex-wrap gap-2">{(o.audience_targeting.behaviours || []).map((x, i) => <span key={i} className="dms-badge">{x}</span>)}</div></div>
                <div><span className="dms-label">Demographics</span><div className="mt-1">{o.audience_targeting.demographics}</div></div>
              </div>
            </OutputBlock>
          )}
          {(o.ads || []).map((ad, i) => (
            <div key={i} className="dms-card p-6 space-y-3" data-testid={`ad-${ad.variant || i}`}>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#1D4E89]">Variant {ad.variant}</span>
                <span className="dms-badge">{ad.format}</span>
                <span className="dms-badge">CTA: {ad.cta_button}</span>
              </div>
              <div><span className="dms-label">Primary Text</span><div className="mt-1 whitespace-pre-wrap leading-relaxed">{ad.primary_text}</div></div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div><span className="dms-label">Headline</span><div className="mt-1 font-semibold">{ad.headline}</div></div>
                <div><span className="dms-label">Description</span><div className="mt-1">{ad.description}</div></div>
              </div>
              <div><span className="dms-label">Creative Brief</span><div className="mt-1 text-[#475569]">{ad.creative_brief}</div></div>
            </div>
          ))}
        </>
      )}
    />
  );
}
